<template>
  <div class="mb-5">
    <v-layout
      :column="$vuetify.display.smAndDown"
      class="mb-3 align-center"
    >
      <div class="py-3 mr-3">
        <img
          :src="image('rudder.png')"
          style="width: 150px;"
        >
      </div>
      <div>
        <h1 class="text-grey-darken-1">
          {{ $t('Service.Brand.repli_seller_portal') }}
        </h1>
        <div>
          <a
            :href="service.service_url"
            target="_blank"
          >{{ service.service_url }}</a>
        </div>
        <div
          style="max-width: 800px;"
          class="mt-3"
        >
          {{ $t('Service.ServiceDetail.repli_seller_portal') }}
        </div>
      </div>
    </v-layout>
    <v-divider />
  </div>
</template>

<script>
  import ServiceIconMixin from '@/components/parts/mixins/ServiceIconMixin'

  export default {
    mixins: [ServiceIconMixin],
    props: {
      service: {
        type: Object,
        required: true
      }
    }
  }
</script>
